import { Wrench, Zap, Hammer, Timer, Music, Sparkles, Speaker, PartyPopper } from "lucide-react";
import Reveal from "./Reveal";
import { useContent } from "../content";

const MAINT_ICONS = [Wrench, Zap, Hammer, Timer];
const EVT_ICONS = [Music, Sparkles, Speaker, PartyPopper];

function ServiceCard({ item, Icon, accent }) {
  return (
    <div
      className={`group relative overflow-hidden rounded-md border p-6 transition-transform duration-300 hover:-translate-y-1 ${
        accent
          ? "border-white/10 bg-[#141414] hover:border-[#e63946]"
          : "border-white/10 bg-[#101010] hover:border-white/40"
      }`}
      data-testid={`service-card-${item.title}`}
    >
      <div
        className={`mb-5 inline-flex h-12 w-12 items-center justify-center rounded-md ${
          accent ? "bg-brand-gradient text-white" : "bg-white/5 text-white"
        }`}
      >
        <Icon size={22} />
      </div>
      <h3 className="font-head text-xl font-medium tracking-tight text-white">{item.title}</h3>
      <p className="mt-2 text-sm font-light leading-relaxed text-white/60">{item.desc}</p>
      {accent && (
        <div className="pointer-events-none absolute -right-16 -top-16 h-32 w-32 rounded-full bg-[#e63946]/20 blur-2xl transition-opacity duration-500 group-hover:opacity-100 opacity-0" />
      )}
    </div>
  );
}

function Division({ data, icons, accent }) {
  return (
    <div className="grid gap-8 lg:grid-cols-12 lg:items-start">
      <Reveal className="lg:col-span-5">
        <div className="lg:sticky lg:top-28">
          <span className="text-xs font-semibold uppercase tracking-[0.25em] text-[#ff4d4d]">
            {data.tag}
          </span>
          <h3 className="mt-4 font-head text-4xl font-semibold uppercase leading-none tracking-tight text-white sm:text-5xl">
            {data.label}
          </h3>
          {data.image && (
            <div className="mt-6 overflow-hidden rounded-md border border-white/10">
              <img
                src={data.image}
                alt={data.label}
                className="h-64 w-full object-cover transition-transform duration-700 hover:scale-105 sm:h-72"
              />
            </div>
          )}
        </div>
      </Reveal>
      <div className="grid gap-4 sm:grid-cols-2 lg:col-span-7">
        {(data.items || []).map((item, i) => (
          <Reveal key={item.title + i} delay={i * 0.06}>
            <ServiceCard item={item} Icon={icons[i % icons.length]} accent={accent} />
          </Reveal>
        ))}
      </div>
    </div>
  );
}

export default function Services() {
  const content = useContent();
  return (
    <section id="services" className="relative bg-[#050505] py-24 sm:py-32" data-testid="services-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal className="mb-16 max-w-2xl">
          <span className="text-xs font-semibold uppercase tracking-[0.25em] text-white/50">
            Nos expertises
          </span>
          <h2 className="mt-4 font-head text-4xl font-semibold uppercase tracking-tight text-white sm:text-5xl md:text-6xl">
            Deux métiers,<br />
            <span className="text-gradient">une même exigence</span>
          </h2>
        </Reveal>

        <div className="space-y-24">
          <Division data={content.maintenance} icons={MAINT_ICONS} accent={false} />
          <Division data={content.evenementiel} icons={EVT_ICONS} accent={true} />
        </div>
      </div>
    </section>
  );
}
